import { render, staticRenderFns } from "./digital-currency-4-price-label.vue?vue&type=template&id=7eddb999&"
import script from "./digital-currency-4-price-label.vue?vue&type=script&lang=ts&"
export * from "./digital-currency-4-price-label.vue?vue&type=script&lang=ts&"
import style0 from "./digital-currency-4-price-label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports